<div id="pedidoLiberar" class="modal fade modal-full-width" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable modal-warning">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <i class="fas fa-exclamation-triangle"></i> Liberar {{pedido?.tipoVenda | pedidoTipoVendaSinonimo}} #{{pedido?.numero}}
                </h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    
                    <div class="row">
                        <div class="form-group col-12">
                            <!-- Carregando pedido -->
                            <span *ngIf="isLoadingPedido">
                                <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando {{pedido?.tipoVenda | pedidoTipoVendaSinonimo}}
                            </span>

                            <ng-template [ngIf]="!isLoadingPedido && pedido">
                                <div class="row">
                                    <div class="form-group col-12">
                                        <label class="col-form-label d-block pb-0">Tipo</label>
                                        <sgt-config-pedido-tipo-venda-badge
                                            [tipoVenda]="pedido.tipoVenda">
                                        </sgt-config-pedido-tipo-venda-badge>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-12 col-md">
                                        <label class="col-form-label">Cliente</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">{{pessoa?.codigoIntegracaoErp}}</span>
                                            </div>                                            
                                            <input type="text" class="form-control" [value]="pessoa?.nome" disabled="disabled" readonly="readonly">
                                        </div>
                                        <p class="form-text text-muted nome-fantasia-cnpj-cpf" *ngIf="pessoa">
                                            {{pessoa.nomeFantasia}} - {{pessoa.cnpjCpf}} - {{pessoa.enderecoPrincipal?.cidade?.nome}} - {{pessoa.enderecoPrincipal?.cidade?.estado?.uf}}
                                        </p>                                        
                                    </div>
                                    <div class="form-group col-12 col-md" *ngIf="!isRepresentante">
                                        <label class="col-form-label">Representante</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">{{pedido.representante?.pessoa?.codigoIntegracaoErp}}</span>
                                            </div>                                            
                                            <input type="text" class="form-control" [value]="pedido.representante?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                        </div>
                                        <p class="form-text text-muted nome-fantasia-cnpj-cpf" *ngIf="pedido.representante?.pessoa">
                                            {{pedido.representante?.pessoa.nomeFantasia}} - {{pedido.representante?.pessoa.cnpjCpf}}
                                        </p>                                        
                                    </div>
                                </div>
                                
                                <sgt-pedido-nao-liberado-card-info
                                    *ngIf="config?.possuiMotivoNaoLiberado"
                                    [input]="pedido">
                                </sgt-pedido-nao-liberado-card-info>

                                <div class="row mt-3">
                                    <div class="form-group col-12">
                                        <label for="justificativaLiberado" class="col-form-label">Justificativa</label>
                                        <textarea class="form-control" [(ngModel)]="req.justificativaLiberado" name="justificativaLiberado" id="justificativaLiberado" 
                                            #justificativaLiberado="ngModel" rows="3" placeholder="Informe a justificativa da liberação do {{pedido?.tipoVenda | pedidoTipoVendaSinonimo}}" required="required" minlength="15">
                                        </textarea>
                                        <p class="form-text text-muted">Justificativa pela qual você está liberando este {{pedido?.tipoVenda | pedidoTipoVendaSinonimo}}</p>
                                        <sgt-form-control-error
                                            *ngIf="justificativaLiberado.errors && justificativaLiberado.errors.required && justificativaLiberado.dirty"
                                            msgError="A justificativa é obrigatória">
                                        </sgt-form-control-error>
                                        <sgt-form-control-error
                                            *ngIf="justificativaLiberado.errors && justificativaLiberado.errors.minlength"
                                            msgError="A justificativa deve ter no mínimo 15 caracteres">
                                        </sgt-form-control-error>                                     
                                    </div>
                                </div>                    
                            </ng-template>
                        </div>
                    </div>     
               
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Fechar
                </button>
                <button type="button" class="btn btn-warning" (click)="liberar()" id="btnLiberar" [disabled]="form.invalid">
                    <i class="far fa-thumbs-up"></i> Liberar
                </button>              
            </div>            
        </div>
    </div>
</div>